import styled from 'styled-components';
import theme from 'styled-theming';

export const tableBackground = theme('name', {
  light: 'rgb(249,249,249)',
  dark: 'rgb(41, 41, 41)',
});

export const FormulaTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 4px 8px;
  }

  th {
    font-size: 13px;
    font-weight: 500;
    text-align: left;
    padding-bottom: 8px;
  }

  td:first-child {
    width: 40%;
  }
  .no-data-cell {
    padding: 140px 20px;
    .title_wrapper {
      display: flex;
      justify-content: center;
    }
  }
  td:nth-child(1),
  td:nth-child(2),
  td:nth-child(3) {
    background-color: ${tableBackground};
    border-radius: 5px 5px 0 0;
  }
`;
